namespace TabAurous.OMS {
    export interface ProductBOMRow {
        BomId?: number;
        ProductId?: number;
        BOMProductId?: number;
        BOMAttributeId?: number;
        Lab?: string;
        CertificateNo?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        CostMethodId?: number;
        SettingId?: number;
        BomRate?: number;
        BomAmount?: number;
        CCBomAmount?: number;
        Purity?: number;
        PureWeight?: number;
        PointerWeight?: number;
        StdPurity?: number;
        Remarks?: string;
        TextureId?: number;
        Parts?: number;
        Markup?: number;
        CenterStone?: boolean;
        ItemType?: string;
        ProductCode?: string;
        ProductName?: string;
        Attribute?: string;
        ShapeId?: number;
        ShapeCode?: string;
        ShapeName?: string;
        ProductTypeId?: number;
        ProductTypeName?: string;
        CategoryId?: number;
        SubCategoryId?: number;
        CategoryCode?: string;
        KaratCode?: string;
        QualityCode?: string;
        QualityName?: string;
        SubCategoryCode?: string;
        StoneColorId?: number;
        StoneColorCode?: string;
        StoneColoreName?: string;
        StoneSizeId?: number;
        SieveId?: number;
        CalcOn?: string;
        GroupSieveId?: number;
        MetalColorId?: number;
        QualityId?: number;
        KaratId?: number;
        ItemTypeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        IsCustomerItem?: boolean;
        HSN?: string;
        TaxCode?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
        GrossWeight?: number;
    }

    export namespace ProductBOMRow {
        export const idProperty = 'BomId';
        export const nameProperty = 'CertificateNo';
        export const localTextPrefix = 'OMS.ProductBOM';
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            BomId = "BomId",
            ProductId = "ProductId",
            BOMProductId = "BOMProductId",
            BOMAttributeId = "BOMAttributeId",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            CostMethodId = "CostMethodId",
            SettingId = "SettingId",
            BomRate = "BomRate",
            BomAmount = "BomAmount",
            CCBomAmount = "CCBomAmount",
            Purity = "Purity",
            PureWeight = "PureWeight",
            PointerWeight = "PointerWeight",
            StdPurity = "StdPurity",
            Remarks = "Remarks",
            TextureId = "TextureId",
            Parts = "Parts",
            Markup = "Markup",
            CenterStone = "CenterStone",
            ItemType = "ItemType",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            Attribute = "Attribute",
            ShapeId = "ShapeId",
            ShapeCode = "ShapeCode",
            ShapeName = "ShapeName",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            CategoryCode = "CategoryCode",
            KaratCode = "KaratCode",
            QualityCode = "QualityCode",
            QualityName = "QualityName",
            SubCategoryCode = "SubCategoryCode",
            StoneColorId = "StoneColorId",
            StoneColorCode = "StoneColorCode",
            StoneColoreName = "StoneColoreName",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            CalcOn = "CalcOn",
            GroupSieveId = "GroupSieveId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            KaratId = "KaratId",
            ItemTypeId = "ItemTypeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            IsCustomerItem = "IsCustomerItem",
            HSN = "HSN",
            TaxCode = "TaxCode",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date",
            GrossWeight = "GrossWeight"
        }
    }
}
